export class ArrayFields {
    constructor(field) {
        this.baseField = field;
        this.addedFields = [];
        this.initialize();
        this.addListeners();
    }

    initialize() {
        if (this.baseField.value) {
            let values = this.baseField.value.split(",");
            values.forEach((value) => {
                this.createNewField(this.baseField, value);
            })
        } else {
            this.createNewField(this.baseField);
        }
    }

    addListeners() {
        const addButton = this.baseField.parentNode.parentNode.querySelector(".array-field__add");
        addButton.addEventListener("click", (event) => {
            event.preventDefault();
            this.createNewField(this.baseField);
        })
    }

    createNewField(baseField, value="") {
        let newField = baseField.cloneNode(true);
        newField.type = "text";
        newField.name = `added-coupon-${this.addedFields.length}`;
        newField.value = value;
        baseField.parentNode.appendChild(newField);
        this.addedFields.push(newField);
        this.fieldChangeListener(newField);
    }

    fieldChangeListener(newField) {
        newField.addEventListener("change", (event) => {
            let newValue = "";
            this.addedFields.forEach((field) => {
                if (newValue && field.value) {
                    newValue += ","
                }
                newValue += field.value;
            });

            console.log(newValue);
            this.baseField.value = newValue;
        })
    }
}

let fields = document.querySelectorAll('.array-field');
[...fields].forEach((field) => new ArrayFields(field));




// WEBPACK FOOTER //
// ./src/my_artis/js/components/array_fields.js